import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import FETCH_INSURANCE_NETWORKS_QUERY from '../queries/fetch_insurance_networks.graphql';
import InsuranceNetworkList from './InsuranceNetworkList';
import PropTypes from 'prop-types';

const ClinicalReferralsIndex = ({ insuranceNetworks }) => {
  const [insuranceNetworkData, setInsuranceNetworkData] = useState([]);

  const { loading } = useQuery(FETCH_INSURANCE_NETWORKS_QUERY, {
    fetchPolicy: 'network-only',
    onCompleted: data => handleCompletedData(data)
  });

  const handleCompletedData = data => {
    const insuranceNetworkData = data.insuranceNetworks.map(item => {
      const selectedItem = insuranceNetworks.find(network => network.insurance_network_id === item.id);

      return {
        ...item,
        tierFlag: selectedItem ? selectedItem.tiering_flg : 'N',
        isSelected: !!selectedItem
      }
    });

    setInsuranceNetworkData(insuranceNetworkData);
  };

  return (
    loading ? <span>Loading...</span> :
      <InsuranceNetworkList insuranceNetworkData={insuranceNetworkData} />
  );
};

ClinicalReferralsIndex.propTypes = {
  insuranceNetworks: PropTypes.arrayOf(
    PropTypes.shape({
      insurance_network_id: PropTypes.string,
      name: PropTypes.string,
      tiering_flg: PropTypes.string
    })
  )
};

export default ClinicalReferralsIndex;
